import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_DEALS = createRequestTypes('ENTITIES_DEALS')
export const ENTITIES_CREATE_DEAL = createRequestTypes('ENTITIES_CREATE_DEAL')
export const ENTITIES_DELETE_DEAL = createRequestTypes('ENTITIES_DELETE_DEAL')

export const deal = {
  request: eventId => action(ENTITIES_DEALS.REQUEST, { eventId }),
  success: (eventId, response) => action(ENTITIES_DEALS.SUCCESS, { eventId, response }),
  failure: (eventId, error) => action(ENTITIES_DEALS.FAILURE, { eventId, error }),
}

export const dealsBatchUpdate = {
  request: () => action(ENTITIES_DEALS.REQUEST),
  success: response => action(ENTITIES_DEALS.SUCCESS, { response }),
  failure: error => action(ENTITIES_DEALS.FAILURE, { error }),
}

export const createDeal = {
  request: () => action(ENTITIES_CREATE_DEAL.REQUEST),
  success: response => action(ENTITIES_CREATE_DEAL.SUCCESS, { response }),
  failure: error => action(ENTITIES_CREATE_DEAL.FAILURE, { error }),
}

export const deleteDeal = {
  request: () => action(ENTITIES_DELETE_DEAL.REQUEST),
  success: response => action(ENTITIES_DELETE_DEAL.SUCCESS, { response }),
  failure: error => action(ENTITIES_DELETE_DEAL.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/deals/deals-actions.js
 **/